module.exports = __webpack_public_path__ + "img/add.7409546c.jpg";